/**
 * @param {string} [country="US"]
 * @param {string} [language="en"]
 * @param {string} [currency="USD"]
 * @return {object}
 */
const getProtocols = (country = "US", language = "en", currency = "USD") => {
    const protocols = {};
    const protocolList = [
        "all-on-4",
        "all-on-6",
        "bredent-fast-and-fixed-4",
        "bredent-fast-and-fixed-6",
        // "bridge", // priceless
        // "bridge-implants", // priceless
        // "crown", // priceless
        // "crown-implants", // priceless
        "dentures-with-bar",
        "full-bridge",
        "full-dentures",
        // "full-jaw-6",
        "full-jaw-6-12",
        "full-jaw-6-14",
        "full-jaw-8-12",
        "full-jaw-8-14",
        "mini-4",
        "mini-6",
        "one-phase-8",
        "preci-vertix",
        // "veneer", // priceless
    ];

    const pricelessProtocolList = [
        "bridge", // priceless
        "bridge-implants", // priceless
        "bridge-implants-one-phase", // priceless
        "crown", // priceless
        "crown-implants", // priceless
        "crown-implants-one-phase", // priceless
        "veneer", // priceless
    ];

    protocolList.forEach((protocol) => {
        // eslint-disable-next-line no-undef
        const baseContent = require(`./${protocol}.json`);
        // const countryList = ["ca", "de", "es", "fr", "gb", "hu", "it", "us", "ga"];
        const countryList = ["us"];

        countryList.forEach((cntry) => {
            // eslint-disable-next-line no-undef
            const content = require(`./countries/${cntry}/${protocol}.json`);

            content.variation_prices.forEach((item, index) => {
                const currency = Object.keys(item)[0];

                baseContent.variation_prices[index][currency] = item[currency];
            });
        });

        protocol = protocol.replace("bredent-", "").replace(/-/g, "_");

        protocols[protocol] = baseContent;
    });

    pricelessProtocolList.forEach((protocol) => {
        // eslint-disable-next-line no-undef
        protocols[protocol.replace("bredent-", "").replace(/-/g, "_")] = require(`./${protocol}.json`);
    });

    return {
        protocols,
        country,
        language,
        currency,
    };
};

export default getProtocols;
